import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Row,
    Typography,
    Card,
    Spin,
    Form,
    Divider,
    Col,
    Collapse,
    Button,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
    LeftOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../../components/layouts/TopContent";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import "../../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { handleFlgStatus } from "../../../../../components/facilities/AccountFacility";
import { rightAction } from "../../../../../redux/actions";


const { Text, Title } = Typography;
const { Panel } = Collapse;

const KYC = (props) => {
    //DECLARED VARIABLES
    const { userData, rightAction } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const { state } = useLocation();
    const [useForm] = Form.useForm();
    const [accountDetails, setAccountDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getDetailById();
        {BOM.HasPermission("MANAGE_KYC_UPDATE") && rightAction(cnt.RIGHT_EDIT_BTN)};
    }, []);

    const getDetailById = () => {
        const params = {
            associations: "all",
        };
        const url = `${apiConfig.savingsAccounts}/${state.id}`;

        let body = {
            session,
            params,
        };
        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                setAccountDetails(objDetail);

                let tempInterestRateChartArray = [];
                let tempChargesArray = [];
                let tempTransactionsArray = [];

                objDetail?.accountChart?.chartSlabs?.forEach((element) => {
                    tempInterestRateChartArray.push({
                        key: element?.id,
                        id: element?.id,
                        periodType: element?.periodType ? element?.periodType?.value : "-",
                        periodFromTo: `${element?.fromPeriod} - ${element?.toPeriod}`,
                        amountRange: element?.amountRangeFrom
                            ? element?.amountRangeFrom
                            : "-",
                        interest: element?.annualInterestRate
                            ? element?.annualInterestRate
                            : "-",
                    });
                });

                objDetail?.charges?.forEach((element) => {
                    tempChargesArray.push({
                        key: element?.id,
                        id: element?.id,
                        name: element?.name ? element?.name : "-",
                        penalty: element?.penalty ? "Penalty" : "Fee",
                        paymentDueAt: element?.chargeTimeType?.value
                            ? element?.chargeTimeType?.value
                            : "-",
                        dueAsOf: element?.dueDate
                            ? BOM.DateTime(element?.dueDate, "only-date")
                            : "-",
                        repeatsOn: element?.feeOnMonthDay
                            ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
                            : "-",
                        calculationType: element?.chargeCalculationType?.value
                            ? element?.chargeCalculationType?.value
                            : "-",
                        due: element?.currency?.code
                            ? `${element?.currency?.code} ${element?.amountOrPercentage}`
                            : "-",
                        paid: element?.currency?.code
                            ? `${element?.currency?.code} ${element?.amountPaid}`
                            : "-",
                        waived: element?.currency?.code
                            ? `${element?.currency?.code} ${element?.amountWaived}`
                            : "-",
                        outstanding: element?.currency?.code
                            ? `${element?.currency?.code} ${element?.amountOutstanding}`
                            : "-",
                        status: handleFlgStatus(
                            element?.isActive ? "active" : "closed",
                            {},
                            true
                        ),
                    });
                });

                objDetail?.transactions?.forEach((element) => {
                    tempTransactionsArray.push({
                        key: element?.id,
                        id: element?.id,
                        transactionDate: element?.date
                            ? BOM.DateTime(element?.date, "only-date")
                            : "-",
                        transactionType: element?.transactionType
                            ? element?.transactionType?.value
                            : "-",
                        debit: element?.debit ? element?.debit : "-",
                        credit: element?.amount ? element?.amount : "-",
                        balance: element?.runningBalance
                            ? `${element?.currency?.code} ${element?.runningBalance}`
                            : "-",
                    });
                });

                setIsLoading(false);
            }
        });
    };

    function onCancel() {
        navigate("/detail-current-account", { state: state });
    }
    const handleOnEdit = () => {
        navigate("/edit-kyc-fields", { state: state });
    }

    return (
        <MainLayout
            isEnableRightSidebar={true}
            onEdit={handleOnEdit}
        >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.detailCurrentAccount}
                pageItems={staticConfig.detailCurrentAccountBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form
                        form={useForm}
                        layout="vertical"
                    >
                        <Divider style={{ marginTop: "-10px" }} />

                        <Row>
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>

                            <Col span={12} style={{ padding: "0px 8px" }}>
                                <CurrencyCloud accountDetails={accountDetails} />
                            </Col>
                            <Col span={12} style={{ padding: "0px 8px" }}>
                                <FSCS accountDetails={accountDetails} />
                            </Col>
                            <Col span={12} style={{ padding: "0px 8px" }}>
                                <ClearBank accountDetails={accountDetails} />
                            </Col>
                        </Row>
                    </Form>
                </Card>

            </Spin>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {
    rightAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(KYC);

function CurrencyCloud(props) {
    const { accountDetails } = props;

    return (
        <Collapse
            style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
            }}
        >
            <Panel
                header={
                    <Title level={5} style={{ margin: 0 }}>
                        {labelConfig.currencyCloud}
                    </Title>
                }
                key="1"
            >
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 15,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 15,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomLeftRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.iban}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.bicOrRoutingCode}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.accountNumberType}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.routingCodeType}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.accountNumberAch}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}

                        >
                            <Text strong>{labelConfig.bicOrRoutingCodeAch}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.accountNumberTypeAch}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.routingCodeTypeAch}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 15,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderTopRightRadius: 0,
                                borderBottomLeftRadius: 0,
                                borderTopLeftRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.multicurrencyAccountPool}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                                borderTopLeftRadius: 0,

                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.externalId
                                    ? accountDetails?.externalId
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>

            </Panel>
        </Collapse>
    );
}

function FSCS(props) {
    const { accountDetails } = props;

    return (
        <Collapse
            style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
            }}
        >
            <Panel
                header={
                    <Title level={5} style={{ margin: 0 }}>
                        {labelConfig.fscs}
                    </Title>
                }
                key="1"
            >
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 15,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 15,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomLeftRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.fscsEligible}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.eligible?.code
                                    ? accountDetails?.eligible?.code
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.statusCode}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                <Text style={{ color: "#b8b8b8" }}>
                                    {accountDetails?.status?.code
                                        ? accountDetails?.status?.code
                                        : "-"}
                                </Text>
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 15,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 15,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                borderTopLeftRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.exclusionIdentifier}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                <Text style={{ color: "#b8b8b8" }}>
                                    {accountDetails?.exclusion?.code
                                        ? accountDetails?.exclusion?.code
                                        : "-"}
                                </Text>
                            </Text>
                        </Col>
                    </Row>
                </div>

            </Panel>
        </Collapse>
    );
}

function ClearBank(props) {
    const { accountDetails } = props;

    return (
        <Collapse
            style={{
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                marginBottom: 25,
            }}
        >
            <Panel
                header={
                    <Title level={5} style={{ margin: 0 }}>
                        {labelConfig.clearBank}
                    </Title>
                }
                key="1"
            >
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 15,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 15,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                borderBottomLeftRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.accountId}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.eligible?.code
                                    ? accountDetails?.eligible?.code
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.MandateDetails}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.eligible?.code
                                    ? accountDetails?.eligible?.code
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.assignedDepositorUser}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.eligible?.code
                                    ? accountDetails?.eligible?.code
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.depositIban}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.eligible?.code
                                    ? accountDetails?.eligible?.code
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 0,
                        borderBottomColor: "#E2E2E2",
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.sortCode}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10, textAlign: "center",
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.eligible?.code
                                    ? accountDetails?.eligible?.code
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        border: "2px solid #F5F5F5",
                        borderRadius: 15,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    }}
                >
                    <Row>
                        <Col
                            span={12}
                            style={{
                                backgroundColor: "#F5F5F5",
                                padding: 10, textAlign: "center",
                                borderRadius: 15,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                borderTopLeftRadius: 0,
                            }}
                        >
                            <Text strong>{labelConfig.accounNumber}</Text>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                padding: 10,
                            }}
                        >
                            <Text style={{ color: "#b8b8b8" }}>
                                {accountDetails?.eligible?.code
                                    ? accountDetails?.eligible?.code
                                    : "-"}
                            </Text>
                        </Col>
                    </Row>
                </div>
            </Panel>
        </Collapse>
    );
}
